import { ChatMessage } from '@assets/component/ChatMessage/ChatMessage';
import { LoadingAnimation } from '@assets/component/LoadingAnimation/LoadingAnimation';
import { ScrollPanel } from '@assets/component/Panel/ScrollPanel/ScrollPanel';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { ChatMessageData } from '@assets/model/RagAPI';
import { useStore, useStoreUI } from '@assets/model/Store';
import { convertMarkdown } from '@assets/utils/Utils';
import { observer } from 'mobx-react';
import { Tooltip } from 'react-tooltip';
import * as style from './ChatContainer.module.less';
import { useEffect } from 'react';
import { toJS } from 'mobx';

interface ChatContainerProps {
    companyId: string;
}

export const ChatContainer = observer((p: ChatContainerProps) => {
    //use id to fetch chat
    const messageData = useStore().reportChatHistory;
    const citationsList = useStore().reportChatCitationsHistory;

    const keys = Object.keys(messageData).sort();

    //Bit awkward to put effect after fetching data from store
    useEffect(() => {
        const chatScroll = document.getElementById('chat-scroll');
        if (chatScroll) {
            setTimeout(() => {
                chatScroll.scrollTop = chatScroll.scrollHeight;
            }, 50);
        }
    }, [keys.length]);

    const reportId = useStore().selectedReportId;
    const messages = [];

    var isLastMessageMe = false;
    keys.forEach(msgId => {
        const msg: ChatMessageData = messageData[msgId];
        if (msg.isMe) {
            isLastMessageMe = true;
            messages.push(<ChatMessage msg={msg} key={msgId} msgId={msgId} />);

            if (msg.response) {
                isLastMessageMe = false;
                //Kinda ugly
                const msgResponse: ChatMessageData = {
                    isMe: false,
                    message: msg.response,
                    date: new Date(),
                    processed: true,
                    raw: msg.raw
                };
                messages.push(
                    <ChatMessage
                        msg={msgResponse}
                        key={msgId + '_response'}
                        msgId={msgId}
                    />
                );
            }
        } else {
            messages.push(
                <ChatMessage msg={msg} key={msgId + '_server'} msgId={msgId} />
            );
        }
    });

    if (isLastMessageMe) {
        messages.push(
            <div className="fade-in" key="animation">
                <LoadingAnimation width={200} height={100} />
            </div>
        );
    }

    const buildTooltipId = (citationDisplayId: string) => {
        return `tooltip_${reportId}_${citationDisplayId}`;
    };

    const makeTooltip = (text: string, tooltipId: string) => {
        const finalId = buildTooltipId(tooltipId);
        const parsed = convertMarkdown(text);
        return (
            <Tooltip
                clickable={true}
                key={finalId}
                id={finalId}
                style={{
                    maxHeight: '400px',
                    maxWidth: '600px',
                    zIndex: 9999,
                    position: 'absolute'
                }}
            >
                <div
                    style={{
                        overflow: 'auto',
                        maxHeight: '400px',
                        maxWidth: '600px',
                        scrollbarColor: '#eaecf0 transparent',
                        scrollbarWidth: 'thin'
                    }}
                    dangerouslySetInnerHTML={{ __html: parsed }}
                />
            </Tooltip>
        );
    };

    var tooltips = [];
    if (citationsList) {
        //data-tooltip-id="my-tooltip

        for (var citationId in citationsList) {
            try {
                const toolGenId = citationId;
                var text = citationsList[citationId];

                tooltips.push(makeTooltip(text, toolGenId));
            } catch (e) {
                console.error('Error in tooltip generation', e);
                console.error('Citation:', citationId);
                //return null;
            }
        }
    }

    return (
        <>
            <div
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '0px', // This prevents the DIV from taking the mouse-input for tooltip hover
                    zIndex: 100000
                }}
            >
                {tooltips}
            </div>
            <ScrollPanel
                onLoadScrollToEnd={true}
                id="chat-scroll"
                className={style.scrollFadeContent}
            >
                <Flex direction="column" justify="end">
                    {messages}
                </Flex>
            </ScrollPanel>
        </>
    );
});
